import type { GroupPermissions } from "@api/groups/types";
import { groupRolesContext } from "@layouts/App/context/GroupRoles";
import { useContext } from "solid-js";

const useGroupPermissions = () => {
	const roles = useContext(groupRolesContext);

	return (userRole: string, permissions: GroupPermissions[]): boolean => {
		const role = roles.find((r) => r.id === userRole);

		if (!role) return false;

		return permissions.every((permission) => role.permissions.includes(permission));
	};
};
export default useGroupPermissions;
